import type { IndexedDBConnector } from '@/types/accessor/common/connector'
import * as indexedDB from './common/indexedDBController'
import { handleError } from '../util/errorHandler'
import type {
  ResQueryAdminDistricts,
  ArgQueryAdminDistricts
} from '@/types/accessor/api/adminDistricts/adminDistricts'
import { getUserAttributesFromStore } from '@/modules/miiaFw/MiiaFwCognito'
import { METHOD, SEND_STATE } from '@/constants/accessor/indexedDB/indexedDB'

const STORE_NAME = 'admin_districts'
const IDB_ERROR_CODE = 'idb_10'

export const set: IndexedDBConnector<ResQueryAdminDistricts, undefined, void> = async (
  data?: ResQueryAdminDistricts
) => {
  const attribute = await getUserAttributesFromStore()
  if (!data) {
    console.error('Data is undefined')
    return
  }
  // dataも自治体コードを持っていることもあるが、持っていない(dataが空配列になる)ケースがあるので、自治体コードは災害storeから取得する
  await indexedDB
    .set(
      STORE_NAME,
      data,
      METHOD.GET,
      SEND_STATE.FETCHED,
      attribute.attribute['disaster-commonattr'].govCode
    )
    .catch(async () => await handleError(IDB_ERROR_CODE))
}

export const get: IndexedDBConnector<ArgQueryAdminDistricts, undefined, unknown> = async (
  key?: ArgQueryAdminDistricts
) => {
  if (!key) {
    console.error('Key is undefined')
    return
  }
  return await indexedDB
    .get(STORE_NAME, key.govCode)
    .catch(async () => await handleError(IDB_ERROR_CODE))
}
